import React, {useState} from 'react';
import style from './RoundButton.less';

export default function RoundButton ({onClick}){
		return (<div onClick={onClick} styleName="RoundButton">+</div>);
}
